module.exports = __webpack_public_path__ + "static/img/041_TO8_1538_og.3db2dee.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/041_TO8_1538_og.jpg
// module id = PMoL
// module chunks = 0